import get from 'lodash/get';

import { AppConfig } from '../core-bundle/config/app-config';

import LaunchDarkly from '@module/launchdarkly';

export const configure = () => {
  const bootstrap = get(
    window,
    '__launch_darkly__.feature_flags',
    'localStorage'
  );
  LaunchDarkly.configure({
    clientID: AppConfig.launchDarkly.clientID,
    enabled: AppConfig.launchDarkly.enabled,
    bootstrap,
    user: AppConfig.launchDarkly.user,
  });
};

export const init = () => {
  if (AppConfig.launchDarkly.enabled === false) {
    return;
  }

  configure();

  return LaunchDarkly.boot();
};

export default init;
